<template>
  <div>
    <el-form
      :model="formParams"
      class="elFormClass"
      ref="ruleForm"
      label-width="auto"
      size="small"
    >
      <el-form-item
        v-for="item in formitem"
        :key="item.model"
        :label="item.label"
        :prop="item.model"
        :rules="formRules.requiredChange"
      >
        <el-select
        clearable
          style="width:99%"
          v-model="formParams[item.model]"
          v-if="item.model == 'catalogueId'"
          placeholder="请选择"
        >
          <el-option
            v-for="op in dictionaryArr"
            :key="op.id"
            :label="op.defValue"
            :value="op.id"
          >
          </el-option>
        </el-select>
        <el-input clearable v-else v-model="formParams[item.model]"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog_bottom">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
    callBack: Function,
  },
  data() {
    return {
      formParams: {},
      dictionaryArr: [],
      formitem: [
        {
          label: "模板名称",
          model: "tName",
        },
        {
          label: "资产目录",
          model: "catalogueId",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    submit() {
      this.$formValidate(this, "ruleForm").then(() => {
        this.$requestAxiosForm(
          {
            url: "/pc/template/temp/add_update",
            data: this.formParams,
          },
          (data) => {
            this.$success();
            this.closeDialog();
            this.callBack();
          }
        );
      });
    },
    init() {
      if (this.row.id) {
        this.formParams = Object.assign({}, this.row);
      }
      /* 资产目录 */
      this.$requestAxios(
        {
          url: "/pc/dictionary/page",
          data: { defType: "catalogue",size:9999 },
        },
        (data) => {
          this.dictionaryArr = data.data;
        }
      );
    },
  },
};
</script>
<style scoped></style>
